// https://remix.run/docs/en/1.19.3/guides/routing
import { WithRouteData } from '../render-routes';
import { Homepage } from '../pages';

export const Index = () => <Homepage />;

export default WithRouteData(Index);
